import React from "react";
import "./css/Navbar.css";
import * as assets from "../assets";
import { UserAuth } from "../context/AuthContext";
import { useState, useEffect, useContext } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";
import { DarkModeContext } from "../App";

const Navbar2 = () => {
  const { darkMode, toggleDarkMode } = useContext(DarkModeContext);
  const [inventoryData, setInventoryData] = useState([]);
  const { user } = UserAuth();

  useEffect(() => {
    const fetchInventoryData = async () => {
      const ref = collection(db, `tbd-database/${user.uid}/companyDetails`);
      const snapshot = await getDocs(ref);
      const inventoryData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setInventoryData(inventoryData);
    };

    fetchInventoryData();
  }, [user.uid]);

  const na = {};
  const color = darkMode
    ? {
        color: "#fcfcfc",
      }
    : na;
  return (
    <div className="navbar">
      <div className="navbarcontainer">
        <div className="navbar_left" style={color}>
          <a href="/" className="title">
            DimeDash
          </a>
        </div>
        <div className="navbar_right">
        <div className="darkmode" onClick={toggleDarkMode}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke={darkMode ? "#FCFCFC" : "#0F0F0F"}
                stroke-width="2"
              />
              <path
                d="M18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364L12 12L18.364 5.63604Z"
                fill={darkMode ? "#FCFCFC" : "#0F0F0F"}
              />
            </svg>
          </div>
          <img src={assets.avatar} alt="userimg" />
          <div className="greeting" style={color}>
            Hey {inventoryData.map((item) => item.companyOwner)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar2;
